
const INITIAL_STATE = true

const ControlSaveEmail = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CONFIG_CONTROL_SAVE_EMAIL_SET':
            return action.payload
        default:
            return state;
    }
}

export default ControlSaveEmail